module.exports = __webpack_public_path__ + "static/media/stepper-arrow.61617c89.svg";